/* eslint-disable import/no-cycle */
// TODO remove import cycles
import Filter from '../filter/filter';
import Search from '../search/search';
import Helpers from '../js/helpers';
import ButtonUp from '../../desktop/button-up/button-up';
/* eslint-enable import/no-cycle */

export default new class SearchModal {
  constructor() {
    this.modalSearchInput = '.js-modalSearchInput';
    this.modalSearchInputClear = '.js-modalSearchClear';
    this.modalSearchContainer = '.js-modalSearchContainer';
    this.closePopup = '.js-modal-close';
    this.modalSearch = '.modal-search';
    this.serviceCheckResultsTable = 'service-check-results__table';
    this.timer = null;

    this.isLastPage = false;
    this.isRequestSent = false;
    this.isScrollPaginationActive = true;
    this.init();
  }

  init() {
    if (!$('.modal-search._global').length) return;
    this.bindEvents();
    this.bindScrollPagination();
  }

  bindEvents() {
    $(document)
    // clear search request & search result container
      .on('click', this.modalSearchInputClear, () => {
        const $modalSearchInput = $(this.modalSearchInput);
        const $modalSearch = $modalSearchInput.closest(this.modalSearch);

        this.clearSearchModal($modalSearchInput);
        this.resetModalSearchFilter($modalSearch);
        $modalSearchInput.focus();

        // clear search input on the page
        $(Search.searchInput).val('');
      })
    // clear search request & search result container on close popup
      .on('click', this.closePopup, () => {
        this.clearSearchModal($(this.modalSearchInput));
      })
    // disable page reload on enter press, send search request
      .keypress((e) => {
        // do some only if modal-search is opened or its mobile and ENTER key is pressed
        if (+e.which === 13
          && (
            Filter.getFilterType().hasClass('_search')
            || (Helpers.isMobile() && $(this.modalSearch).hasClass('_active'))
          )
        ) {
          e.preventDefault();

          $(this.modalSearchContainer).empty();
          this.isLastPage = false;
          Search.page = 1;

          Filter.getFilterParams(Search.page);
        }
      })
    // send search request
      .on('input', this.modalSearchInput, (e) => {
        const requestText = $(e.currentTarget).val().trim();

        // set timeout until send sequest
        if (requestText.length > Search.minLengthForRequest) {
          if (this.timer) { clearTimeout(this.timer); }

          this.timer = setTimeout(() => {
            // send search request

            $(this.modalSearchContainer).empty();
            this.isLastPage = false;
            Search.page = 1;

            Filter.getFilterParams(Search.page);
          }, Search.delayForRequest);
        }
      });
  }

  resetModalSearchFilter($modalSearch) {
    Filter.resetDateFilter();
    Filter.resetToDefaultValuesInSorrting($modalSearch);
    Filter.resetToDefaultValuesInCheckbox($modalSearch);
    Filter.resetJournalFilter();
    Filter.setDefaultSectionItemSelected();
    Filter.hideSelectJournalBtn();
  }

  bindScrollPagination() {
    // activate pagination on scroll popup to the bottom
    $(this.modalSearch).scroll((e) => {
      const isPaginationRequest = true;
      const topModalHeight = $('.modal-search__top').outerHeight();
      const bottomModalHeight = $('.modal-search__bottom').outerHeight();
      const $modalScrollTop = +$(this.modalSearch).scrollTop();
      const totalModalHeight = topModalHeight + bottomModalHeight;
      const windowHeight = window.innerHeight;

      if (
        !this.isLastPage
        && !this.isRequestSent
          && Math.floor(totalModalHeight) - windowHeight <= ($modalScrollTop)
      ) {
        Search.page += 1;
        Filter.getFilterParams(Search.page, isPaginationRequest);
      }

      ButtonUp.toggleButton($(e.target));
    });
  }

  unbindScroll() {
    $(this.modalSearch).off('scroll');

    setTimeout(() => {
      this.bindScrollPagination();
    }, 30);
  }

  /**
     *  clear search modal results and inputs
     */
  clearSearchModal($modalSearchInput) {
    if (Helpers.isMobile()) {
      Helpers.toggleClassToElement($(`.${this.serviceCheckResultsTable}`), '_updated');
    }

    $(Search.searchInput).val('');
    $modalSearchInput.val('');
    $(this.modalSearchContainer).empty();
  }
}();
